import React, { useState } from 'react';
import api from '../services/api';

const ReenviarVerificacion = ({ email }) => {
  const [estado, setEstado] = useState('idle'); // idle | loading | enviado | error

  const reenviar = async () => {
    setEstado('loading');
    try {
      await api.post('/auth/reenviar-verificacion', { email });
      setEstado('enviado');
    } catch {
      setEstado('error');
    }
  };

  if (estado === 'enviado') {
    return (
      <p style={{ color: '#059669', fontSize: '0.85rem', fontWeight: '600', margin: '0 0 0.5rem' }}>
        ✅ Correo reenviado. Revisa tu bandeja de entrada.
      </p>
    );
  }

  if (estado === 'error') {
    return (
      <p style={{ color: '#dc2626', fontSize: '0.85rem', margin: '0 0 0.5rem' }}>
        No se pudo reenviar.{' '}
        <button onClick={() => setEstado('idle')} style={{ background: 'none', border: 'none', color: '#3b82f6', cursor: 'pointer', textDecoration: 'underline', padding: 0, fontSize: '0.85rem' }}>
          Intentar de nuevo
        </button>
      </p>
    );
  }

  return (
    <button
      onClick={reenviar}
      disabled={estado === 'loading'}
      style={{
        background: 'none',
        border: 'none',
        color: '#3b82f6',
        fontSize: '0.85rem',
        fontWeight: '600',
        cursor: estado === 'loading' ? 'not-allowed' : 'pointer',
        textDecoration: 'underline',
        padding: 0,
        display: 'inline',
      }}
    >
      {estado === 'loading' ? 'Enviando...' : 'reenviar el correo de verificación'}
    </button>
  );
};

export default ReenviarVerificacion;
